var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdddevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65316 4.03477C8.68314 3.9313 7.70482 4.05938 6.78081 4.41082C5.85679 4.76227 5.00742 5.32933 4.28705 6.07572C3.56668 6.82211 2.99117 7.7314 2.59735 8.7454C2.20353 9.7594 2.00008 10.8558 2 11.9644V15.5575C2 15.6749 2.04097 15.7874 2.1139 15.8704C2.18683 15.9534 2.28574 16 2.38888 16C2.49202 16 2.59093 15.9534 2.66386 15.8704C2.73679 15.7874 2.77776 15.6749 2.77776 15.5575V12.1547C2.7597 10.3941 3.30927 8.68696 4.32252 7.35624C5.33578 6.02551 6.74246 5.16343 8.27652 4.93305C9.14866 4.81689 10.0325 4.91211 10.87 5.21243C11.7075 5.51274 12.4796 6.01137 13.1357 6.67552C13.7917 7.33966 14.3168 8.15429 14.6763 9.06584C15.0359 9.97739 15.2218 10.9652 15.2219 11.9644V15.5575C15.2219 15.6749 15.2629 15.7874 15.3358 15.8704C15.4087 15.9534 15.5077 16 15.6108 16C15.7139 16 15.8128 15.9534 15.8858 15.8704C15.9587 15.7874 15.9997 15.6749 15.9997 15.5575V12.1502C16.0165 10.1422 15.376 8.19896 14.2028 6.69881C13.0297 5.19866 11.4078 4.24901 9.65316 4.03477Z",
    stroke: "#DADADA",
    strokeWidth: 0.8,
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0278 10.5C10.86 10.4996 10.6924 10.5114 10.5256 10.5356V18.9644C10.6924 18.9886 10.86 19.0004 11.0278 19C12.155 19 13.236 18.552 14.033 17.755C14.83 16.958 15.2778 15.8772 15.2778 14.75C15.2778 13.6228 14.83 12.542 14.033 11.745C13.236 10.948 12.155 10.5 11.0278 10.5Z",
    stroke: "#DADADA",
    strokeWidth: 1,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2V8M16.5 5H22.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdddevices);
export default __webpack_public_path__ + "static/media/add devices.95bd80f66fb04a8e2234f523300a5b88.svg";
export { ForwardRef as ReactComponent };